"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productUnserializeFactory = void 0;
const ProductBlueprint_1 = require("../models/ProductBlueprint");
const StockedProduct_1 = require("../models/StockedProduct");
const isSerializedProductBlueprint_1 = require("./isSerializedProductBlueprint");
const isSerializedStockedProduct_1 = require("./isSerializedStockedProduct");
/**
 * Factory helper function to convert a particular product data
 * structure to its model equivalent
 */
const productUnserializeFactory = (product) => {
    if ((0, isSerializedProductBlueprint_1.isSerializedProductBlueprint)(product)) {
        return ProductBlueprint_1.ProductBlueprint.unserialize(product);
    }
    if ((0, isSerializedStockedProduct_1.isSerializedStockedProduct)(product)) {
        return StockedProduct_1.StockedProduct.unserialize(product);
    }
    throw new Error("Unknown product structure");
};
exports.productUnserializeFactory = productUnserializeFactory;
//# sourceMappingURL=productUnserializeFactory.js.map